import { setAuthAction } from '@app/store/auth';
import { all, takeEvery } from 'redux-saga/effects';
import { loadAppWorker } from './loadAppWorker';

export function* appSagaWatcher() {
  yield all([loadAppWorker(), takeEvery(setAuthAction.TYPE, loadAppWorker)]);
}
